export const environment = {
  production: true,
  configApiURL: 'https://rd1-api-backoffice.azurewebsites.net/v2/',
  devtunnelEnabled: false,
  devtunnelApiUrl: '',
  messageDuration: 2500,
  templateEditorUrl: 'https://template-editor.dev.tymes4-infra.com'
}
